export default function TickTalairoIco({ style }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...style }}
    >
      <circle
        cx="8"
        cy="8"
        r="7.33333"
        stroke="#D5DADD"
        stroke-width="1.33333"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 8C0 3.58172 3.58172 0 8 0C12.4182 0 16 3.58172 16 8C16 12.4182 12.4182 16 8 16C3.58172 16 0 12.4182 0 8ZM10.9657 5.83431C11.2781 6.14674 11.2781 6.65328 10.9657 6.96568L8.01944 9.91192C7.56688 10.3645 6.83312 10.3645 6.38054 9.91192L5.03431 8.56568C4.7219 8.25328 4.7219 7.74672 5.03431 7.43432C5.34674 7.12192 5.85326 7.12192 6.16569 7.43432L7.2 8.46864L9.83432 5.83431C10.1467 5.5219 10.6533 5.5219 10.9657 5.83431Z"
        fill="#7F56D9"
      />
    </svg>
  );
}
